// extracted by mini-css-extract-plugin
export default {"containerLoading":"loading-styles_component_containerLoading__kqM6Q","textLoading":"loading-styles_component_textLoading__l2RXd","imgGift":"loading-styles_component_imgGift__mEPrJ"};